import React, { useEffect, useState } from "react";
import { Label, UncontrolledTooltip } from "reactstrap";
import { BasicDetailsTypesProfile } from "../../../types/profile";
import { fileToBase64 } from "../../../utils";
import { useProfileImage } from "../../../context/ProfileImageContext";
import { apiCore } from "../../../api/apiCore";

interface UserCoverImageProps {
  basicDetails: BasicDetailsTypesProfile;
}
const UserCoverImage = ({ basicDetails }: UserCoverImageProps) => {

  const { coverImage, updateCover, postCoverProfile } = useProfileImage();

  const onChangeProfileCover = async (e: any) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const base64 = await fileToBase64(file);
    updateCover(base64);

    //Envia para BKEnd
    await postCoverProfile(basicDetails.id, base64);
  };

  return (
    <div className="user-profile-img">
      <img
        src={coverImage}
        className="profile-img profile-foreground-img"
        style={{ height: "160px" }}
        alt=""
      />
      <div className="overlay-content">
        <div>
          <div className="user-chat-nav p-3">
            <div className="d-flex w-100 align-items-center">
              <div className="flex-grow-1">
                <h5 className="text-white mb-0">Configuração</h5>
              </div>
              <div className="flex-shrink-0">
                <div
                  className="avatar-xs p-0 rounded-circle profile-photo-edit"
                  id="change-cover"
                >
                  <input
                    id="profile-foreground-img-file-input"
                    type="file"
                    accept="image/png, image/jpeg"
                    className="profile-foreground-img-file-input"
                    onChange={e => onChangeProfileCover(e)}
                  />
                  <Label
                    htmlFor="profile-foreground-img-file-input"
                    className="profile-photo-edit avatar-xs"
                  >
                    <span className="avatar-title rounded-circle bg-light text-body">
                      <i className="bx bxs-pencil"></i>
                    </span>
                  </Label>
                </div>
                <UncontrolledTooltip target="change-cover" placement="bottom" transition={{ timeout: 0 }}>
                  Change Background
                </UncontrolledTooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserCoverImage;
